export const therapyData = {
    title: "therapyData.title",
    subtitle: "therapyData.subtitle",
    sections: [
        {
            title: "therapyData.sections.0.title",
            content: "therapyData.sections.0.content",
        },
        {
            title: "therapyData.sections.1.title",
            content: "therapyData.sections.1.content",
        },
        {
            title: "therapyData.sections.2.title",
            content: "therapyData.sections.2.content",
        },
        {
            title: "therapyData.sections.3.title",
            content: "therapyData.sections.3.content",
        },
        {
            title: "therapyData.sections.4.title",
            content: "therapyData.sections.4.content",
        },
    ],
    bibliography: [
        "therapyData.bibliography.0",
        "therapyData.bibliography.1",
        "therapyData.bibliography.2",
        "therapyData.bibliography.3",
        "therapyData.bibliography.4",
    ],
};

export default therapyData;